// extracted by mini-css-extract-plugin
module.exports = {"Cover":"RatioImage__Cover--30i0u"};